import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import PickupOperatorApi from './PickupOperatorApi';
import PickupOperatorActions from './Components/PickupOperatorActions';

let settings;

export default settings = {
    key: 'pickup/operators',
    zone: 'pickup',
    path: '/pickup/operators',
    title: "Pickup Operator",
    endpoint: PickupOperatorApi.endpoint,
    modelName: 'PickupOperator',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewPickupOperator"],
    viewCaps: ["viewPickupOperator"],
    createCaps: ["createPickupOperator"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All Operators",
                path: settings.path
            },
            // {
            //     label: "Draft",
            //     path: settings.path + "/status/draft",
            // },
            // {
            //     label: "Preview",
            //     path: settings.path + "/status/preview",
            // },
            // {
            //     label: "Publish",
            //     path: settings.path + "/status/publish",
            // },
            // {
            //     label: "Archive",
            //     path: settings.path + "/status/archive",
            // },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: PickupOperatorApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ["host"], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text"
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "draft", label: "Draft" },
                    { value: "preview", label: "Preview" },
                    { value: "publish", label: "Publish" },
                    { value: "archive", label: "Archive" },
                ],
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
            },
            // {
            //     label: "Thumbnail",
            //     key: "thumbnail.fileId",
            //     format: "image",
            //     filters: {
            //         width: 40,
            //         height: 40
            //     },
            //     style: { width: 60 }
            // },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <PickupOperatorActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: PickupOperatorApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ["host"] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};